module.exports = __webpack_public_path__ + "static/logo-vjl-91b33d05ee307a224a877b6159536418.svg";